import axiosInstance from '@/utils/httpUtil'

import { setting } from '@/setting'

const miaomiaoxiangBaseUrl = setting.miaomiaoxiangBaseUrl
export const adminToolApi = {

    scratch_recruitment: () => {
        return axiosInstance.get(`${miaomiaoxiangBaseUrl}/scratch_recruitment`,{
            responseType: 'blob', // 指定回傳的資料類型為二進制
          })
    },
}